module.exports = __webpack_public_path__ + "static/media/profile.25ec7c98.jpg";